import Vue from 'vue';
import VueSimpleSpinner from 'vue-simple-spinner';
import HttpMixin from '@/mixins/HttpMixin';

export default Vue.component('pay-queue', {
  name: 'PayQueue',
  components: {
    VueSimpleSpinner
  },
  mixins: [ HttpMixin ],
  data () {
    return {
      cardExpanded: false,
      loadingInitialData: false,
      providers: []
    };
  },
  computed: {
    payQueueCounter (): number {
      return this.$store.state.invoices.payQueueCounter;
    }
  },
  watch: {
    async payQueueCounter () {
      await this.fetch();
    }
  },
  async created () {
    await this.expandCard();
  },
  methods: {
    async expandCard() {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        await this.fetch();
      }
    },
    async fetch() {
      this.providers = await (this as any).httpGet('/provider-payments/queue?isReadyToPay=false&isCountOnly=false', 'An error occurred retrieving Providers.');
    },
    async readyToPay(invoiceId = 0, providerId = 0) {
      await (this as any).httpPut(`/provider-payments/queue?readyToPay=true&invoiceId=${invoiceId}&providerId=${providerId}`, 'An error occurred marking Provider(s) Ready to Pay.', undefined, false);
      await this.fetch();
      this.$store.commit('invoices/queueToReady');
    },
    async remove(invoiceId = 0, providerId = 0) {
      await (this as any).httpDelete(`/provider-payments/queue?invoiceId=${invoiceId}&providerId=${providerId}`, 'An error occurred removing Provider(s).', false);
      await this.fetch();
    },
    browseToProvider (providerId: number) {
      window.open("/providers/" + providerId, '_blank');
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/payments/cards/payQueue/PayQueue.ts